<template>
  <el-select v-model="val" filterable remote reserve-keyword placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="change" clearable>
    <el-option v-for="(item, index) in options" :key="index" :label="item.label" :value="item.value"></el-option>
  </el-select>
</template>
<script>
  export default {
    name: 'mc-remote-select',
    props: ['searchStr', 'pageSize', 'list', 'url', 'query', 'value', 'maxNum', 'ajaxData', 'label'],
    model: {
      prop: 'searchStr',
      event: 'update'
    },
    data () {
      return {
        val: '',
        options: [],
        loading: false
      }
    },
    watch: {
      searchStr() {
        if (this.val !== this.searchStr) {
          this.val = this.searchStr
          this.remoteMethod(this.val)
        }
        this.val = this.searchStr
      }
    },
    methods: {
      remoteMethod (query) {
        this.options = []
        if (query && query !== '') {
          let url = this.url || 'http://t.com/search'
          this.loading = true
          let params = Object.assign({[this.pageSize || 'pageSize']: this.maxNum || 5}, {[this.query]: query}, this.ajaxData)
          this.$ajax.get(url, params).then(rs => {
            if (rs && rs.result && rs.result.length !== 0) {
              this.loading = false
              let ar = []
              let valueAr = []
              let data = rs.result[this.list || 'list'] || rs.result
              if (data && data.length > 0) {
                data.forEach(item => {
                  let label = `${item[this.val || this.query]} ${item[this.label || this.query]}`
                  let value = item[this.value || this.query]
                  // let flag = (label && label.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1)
                  // if (this.$attrs['accurate'] !== undefined) {
                  //   flag = (label && (label.toString().toLowerCase() === query.toString().toLowerCase()))
                  // }
                  // if (flag) {
                    if (valueAr.indexOf(value) < 0) {
                      valueAr.push(value)
                      ar.push({label, value})
                    }
                  // }
                })
              }
              this.options = [...ar]
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.options = []
        }
      },
      change (val) {
        let obj = this.options.find( item => item.value == val)
        this.$emit('updateRow', obj)
        this.$emit('update', this.val)
      }
    },
    mounted () {
      this.val = this.searchStr
      this.remoteMethod(this.val)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/mc-ui/remote-select/index.vue